import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Documents from './pages/Documents';
import BackupTool from './pages/BackupTool';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import Publications from './pages/Publications';
import ArticleDetail from './pages/ArticleDetail';
import Registration from './pages/Registration';
import CheckIn from './pages/CheckIn';
import UserLogin from './pages/UserLogin';
import UserProfile from './pages/UserProfile';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/acesso" element={<UserLogin />} />
          <Route path="/perfil" element={<UserProfile />} />
          <Route 
            path="/admin/dashboard" 
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
          <Route path="/publicacoes" element={<Publications />} />
          <Route path="/publicacoes/:id" element={<ArticleDetail />} />
          <Route path="/inscricao" element={<Registration />} />
          <Route path="/checkin/:dia" element={<CheckIn />} />
          <Route path="/sobre-nosotros" element={<About />} />
          <Route path="/contacto" element={<Contact />} />
          <Route path="/documentos" element={<Documents />} />
          <Route path="/tools/db-backup" element={<BackupTool />} />
          <Route path="/admin" element={<Login />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
